export default {
  LIST: {
    storeName: 'List',
    paramName: '0',
  },
  CARD: {
    storeName: 'Card',
    paramName: '1',
  },
  POPUP: {
    storeName: 'Popup',
    paramName: '2',
  },
}
